import React from 'react';
import { Modal, Typography, Button } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';

const { Text, Title } = Typography;

/**
 * Modal component for confirming the addition of products to a catalogue
 * 
 * @param {Object} props - Component properties
 * @param {boolean} props.visible - Whether the modal is visible
 * @param {Function} props.onCancel - Function called when modal is cancelled
 * @param {Function} props.onConfirm - Function called when user confirms
 * @param {number} props.selectedCount - Number of selected SKUs
 * @param {string} props.catalogueName - Name of the selected catalogue
 * @param {boolean} props.loading - Whether the operation is in progress
 */
const ConfirmAddModal = ({
    visible,
    onCancel,
    onConfirm,
    selectedCount = 0,
    catalogueName = '',
    loading = false
}) => {
    return (
        <Modal
            title={
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <CheckCircleOutlined style={{ color: '#52c41a', fontSize: '20px' }} />
                    <span>Confirm Addition</span>
                </div>
            }
            open={visible}
            onCancel={onCancel}
            footer={[
                <Button key="cancel" onClick={onCancel} disabled={loading}>
                    Cancel
                </Button>,
                <Button
                    key="confirm"
                    type="primary"
                    onClick={onConfirm}
                    loading={loading}
                >
                    Confirm Addition
                </Button>
            ]}
            centered
            width={500}
            maskClosable={!loading}
            closable={!loading}
        >
            <div style={{ padding: '20px 0' }}>
                <Title level={4} style={{ color: '#52c41a', marginBottom: '20px' }}>
                    Success!
                </Title>

                <div style={{ marginBottom: '20px', lineHeight: '1.6' }}>
                    <Text style={{ fontSize: '16px' }}>
                        The <Text strong>{selectedCount}</Text> selected SKU{selectedCount !== 1 ? 's' : ''} will be added to the
                        <Text strong> {catalogueName}</Text> catalogue.
                    </Text>
                </div>

                <div style={{
                    padding: '16px',
                    backgroundColor: '#f6ffed',
                    border: '1px solid #b7eb8f',
                    borderRadius: '6px',
                    marginTop: '16px'
                }}>
                    <Text style={{ color: '#52c41a' }}>
                        Once the process is finished, you will receive a notification and the SKUs will be visible within the catalogue.
                    </Text>
                </div>
            </div>
        </Modal>
    );
};

export default ConfirmAddModal; 